<script setup>
import { onMounted, ref, useTemplateRef } from 'vue'
import { printResponseProperty } from '@/libs/utils/questions/radio_checkbox.js'

import QuestionGroupComponent from '@/components/CMB/Components/QuestionGroupComponent.vue'

const props = defineProps(['handleAnswer', 'compiledPoll', 'question'])
const inputs = useTemplateRef('form-check-input')
const answerNote = defineModel('answerNote')
const selectedValues = ref([])

const selectValueF = (value, event) => {
  if (!props.handleAnswer) {
    return
  }

  if (event.target.checked) {
    selectedValues.value.push(value['value'])
  } else {
    selectedValues.value.splice(selectedValues.value.indexOf(value['value']), 1)
  }

  let answerValue = ''
  selectedValues.value.forEach((el, index) => {
    answerValue += el
    if (index < selectedValues.value.length - 1) {
      answerValue += '|'
    }
  })

  if (answerValue.trim() !== '') {
    if (props.question.required) {
      inputs.value.forEach(el => {
        el.required = false
        el.setCustomValidity('')
      })
    }
    props.handleAnswer(props.question['reference'], answerValue, false, answerNote.value)
  } else {
    if (props.question.required) {
      inputs.value.forEach(el => {
        el.required = true
        el.setCustomValidity('Una delle caselle deve essere spuntata')
      })
    }
    props.handleAnswer(props.question['reference'], null, false, answerNote.value)
  }
}

const handleNote = () => {
  if (!props.handleAnswer) {
    return
  }

  let answerValue = ''
  selectedValues.value.forEach((el, index) => {
    answerValue += el
    if (index < selectedValues.value.length - 1) {
      answerValue += '|'
    }
  })

  props.handleAnswer(props.question['reference'], answerValue.trim() === '' ? null : answerValue, false, answerNote.value)
}

function checkQuestionGroupDependentQuestionCondition(childQuestionGroup) {
  let condition = childQuestionGroup['dependentQuestionCondition']
  let found = false
  selectedValues.value.map(el => {
    if (condition && condition === el.value) {
      found = true
    }
  })

  if (!found) {
    resetAnswersChildQuestionGroup(childQuestionGroup)
  }
  return found
}

function resetAnswersChildQuestionGroup(childQuestionGroup) {
  let questions = childQuestionGroup['questions']
  questions.forEach(question => {
    props.handleAnswer(question['reference'], null, true, answerNote.value)
    if (
      question['childQuestionGroups'] &&
      question['childQuestionGroups'].length > 0
    ) {
      question['childQuestionGroups'].forEach(group => {
        resetAnswersChildQuestionGroup(group)
      })
    }
  })
}

onMounted(() => {
  props.compiledPoll['answers'].forEach(el => {
    if (el['questionReference'] === props.question['reference']) {
      if (el['note']) {
        answerNote.value = el['note']
      }
      if (el['value']) {
        let values = el['value'].split('|')
        values.forEach(value => {
          selectedValues.value.push(value)
        })
      }
    }
  })

  let answerValue = ''
  selectedValues.value.forEach((el, index) => {
    answerValue += el
    if (index < selectedValues.value.length - 1) {
      answerValue += '|'
    }
  })

  if (answerValue.trim() !== '') {
    if (props.question.required) {
      inputs.value.forEach(el => {
        el.required = false
        el.setCustomValidity('')
      })
    }

    if (props.handleAnswer !== null) {
      props.handleAnswer(props.question['reference'], answerValue, false, answerNote.value)
    }
  } else {
    if (props.question.required) {
      inputs.value.forEach(el => {
        el.required = true
        el.setCustomValidity('Una delle caselle deve essere spuntata')
      })
    }
    if (props.handleAnswer !== null) {
      props.handleAnswer(props.question['reference'], null, false, answerNote.value)
    }
  }
})
</script>

<template>
  <div>
    <label
      :for="'textQuestion' + question['id']"
      :class="'form-label' + (question.required ? ' fw-bold ' : '')"
    >{{ question.text }} {{ question.required ? '*' : '' }}</label
    >
    <div
      class="form-check"
      v-for="selectValue in question['additionalProperties']['select_values']"
      :key="selectValue.value"
    >
      <input
        class="form-check-input"
        ref="form-check-input"
        :checked="selectedValues.includes(selectValue.value)"
        :disabled="compiledPoll['state'] === 'filled' || handleAnswer === null"
        type="checkbox"
        :name="selectValue['value']"
        :id="selectValue['value']"
        @change="selectValueF(selectValue, $event)"
      />
      <label class="form-check-label" :for="selectValue['value']">
        {{ selectValue['label'] }}
      </label>

      <template v-if="selectValue?.properties">
        <div v-for="(property) in selectValue.properties"
             class="form-text"
        >
          {{ printResponseProperty(property) }}
        </div>
      </template>
    </div>

    <small v-if="question.helper" class="form-text">
      {{ question.helper }}
    </small>

    <div
      v-for="childQuestionGroup in question['childQuestionGroups']"
      :key="childQuestionGroup['id']"
    >
      <div
        class="mt-2"
        v-if="checkQuestionGroupDependentQuestionCondition(childQuestionGroup)"
      >
        <question-group-component
          :compiled-poll="compiledPoll"
          :handle-answer="handleAnswer"
          :question-group="childQuestionGroup"
        ></question-group-component>
      </div>
    </div>

    <div v-if="question.hasNote" class="pt-2">
      <div class="pe-2">
        <label :for="'noteQuestion'+question['id']" class="form-label">Note</label>
        <textarea @input="handleNote"
                  class="form-control" rows="2" placeholder="Inserisci note"
                  :id="'noteQuestion'+question['id']"
                  v-model="answerNote"
                  :disabled="!(compiledPoll['state'] !== 'filled' && handleAnswer !== null)"></textarea>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss"></style>
